import React, { Component } from 'react';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions/app-actions';
import { Text } from '../../components';
import { Button } from '@kmx/legos-react-button';
import { RadioButton } from '@kmx/legos-react-radio-button';
import AppForm from '../constants/app-forms';
const TIMER_LENGTH = 90;

class Questions extends Component {
  constructor(props) {
    super(props);
    this.formType = AppForm.Questions;
    this.state = {
      answer: null,
      submitting: false,
      question: null,
      timer: TIMER_LENGTH,
    };

    this.timer = 0;
    this.onQuestionAnswer = this.onQuestionAnswer.bind(this);
    this.onSubmitAnswer = this.onSubmitAnswer.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    this.onSuccessfulAnswer = this.onSuccessfulAnswer.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
  }

  scrollTop() {
    window && window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer() {
    if (this.state.timer !== 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    if (this.state.timer === 0) {
      clearInterval(this.timer);
      return this.props.userTimeout();
    } else {
      this.setState((prevState) => ({ timer: prevState.timer - 1 }));
    }
  }

  onQuestionAnswer(value) {
    !this.props.isPosting && this.setState({ answer: value });
  }

  onSubmitAnswer() {
    if (this.state.answer !== null && !this.props.isPosting) {
      this.setState({ submitting: true });
      this.props.postQuestionAnswer(this.state.answer).then((shouldScroll) => this.onSuccessfulAnswer(shouldScroll));
    }

    //put here the handle next step call after success or failure?
  }

  onSuccessfulAnswer(shouldScroll) {
    if (shouldScroll) {
      clearInterval(this.timer);
      this.setState({ submitting: false, answer: null, timer: TIMER_LENGTH });
      this.startTimer();
      this.scrollTop();
    }

    //dispatching app actions will set the results of KBA in props available to app,
    this.props.handleNextStep(AppForm.Questions);
  }
  render() {
    const { answer, submitting, timer } = this.state;
    const { question, productType } = this.props;

    if (question === null) {
return null;
}
    const disabled = answer === null || submitting;

    return (
      <div className={classNames(['questions', { submitting: submitting }])}>
        <Text.Display3 className='m-b-m'>We are going to ask you some questions to verify your identity</Text.Display3>

        <Text.Body1 className='m-b-m'>
          <span className='attention-text'>CarMax DOES NOT have access to this information</span>. A third party identity verification
          service maintains this information. You have <span className='attention-text'>{timer} seconds</span> to answer the following
          question.
        </Text.Body1>

        <p id='lexis-nexis-question'>{question.text.statement}</p>
        {productType === 'Discovery' && (
          <Text.FinePrint id='helper-text' className='p-b-m helper-text'>
            {question.helpText.statement}
          </Text.FinePrint>
        )}
        <form noValidate>
          <fieldset className={classNames('kmx-flex-wrapper')} aria-label='Discovery questions'>
            {question.choices.map((choice) => {
              return (
                <>
                  <RadioButton
                    className='fs-mask'
                    key={choice.choiceId}
                    deselectable
                    disabled={false}
                    id={choice.choiceId}
                    name={'answerGroup'}
                    label={choice.text.statement}
                    value={choice.choiceId.toString()}
                    onChange={(e) => {
                      this.setState({ answer: e.target.value });
                    }}
                    checked={this.state.answer == choice.choiceId.toString()}
                  />
                  <br />
                </>
              );
            })}

            <Button className='kmx-button--full m-t-l' disabled={disabled} level='primary' type='button' onClick={this.onSubmitAnswer}>
              Submit
            </Button>
          </fieldset>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ app }) => {
  return {
    isPosting: app.isPosting,
    question: app.question,
    productType: app.productType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...actions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Questions);
